<template>
  <div class="evaluate-con">
    <div
      class="goodsStyle acea-row row-between"
      v-if="unique !== '-1' && orderCon.productInfo"
    >
      <div class="titleText">商品</div>
      <div class="pictrue">
        <img :src="orderCon.productInfo.image" class="image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">
          {{ orderCon.productInfo.storeName }}
        </div>
        <div class="money">
          <div>￥{{ orderCon.productInfo.price }}</div>
          <div class="num">x{{ orderCon.cartNum }}</div>
        </div>
        <div class="sku line2">
          规格:
          <span>{{
            orderCon.productInfo.attrInfo
              ? orderCon.productInfo.attrInfo.suk
              : "默认"
          }}</span>
        </div>
      </div>
    </div>
    <div class="goodsStyle acea-row row-between">
      <div class="titleText">选择服务类型</div>
      <ul>
        <template v-if="unique !== '-1'">
          <li
            @click="$router.push({ path: '/order/refund/' + orderCon.orderId })"
          >
            <div class="acea-row">
              <div class="pictrue logo">
                <img src="@assets/images/退款.png" class="image" />
              </div>
              <div class="text acea-row row-between logotext">
                <div class="name line2">
                  我要退款（无需退货）
                </div>
                <div class="service-remark line2">
                  没收到货，或与卖家协商同意不用退货只退款
                </div>
              </div>
              <div class="acea-row">
                <div class="pictrue logo">
                  <img src="@assets/images/箭头.png" class="image" />
                </div>
              </div>
            </div>
          </li>
          <li
            @click="$router.push({ path: '/order/refund/' + orderCon.orderId })"
          >
            <div class="acea-row">
              <div class="pictrue logo">
                <img src="@assets/images/退货退款.png" class="image" />
              </div>
              <div class="text acea-row row-between logotext">
                <div class="name line2">
                  我要退货退款
                </div>
                <div class="service-remark line2">
                  已收到货，需要退还收到的货物
                </div>
              </div>
              <div class="acea-row">
                <div class="pictrue logo">
                  <img src="@assets/images/箭头.png" class="image" />
                </div>
              </div>
            </div>
          </li>
          <template v-if="evaluate === '2' || evaluate === '3'">
            <li
              @click="
                $router.push({
                  path: '/workOrder/create/0/' + orderCon.orderId
                })
              "
            >
              <div class="acea-row">
                <div class="pictrue logo">
                  <img src="@assets/images/安装.png" class="image" />
                </div>
                <div class="text acea-row row-between logotext">
                  <div class="name line2">
                    售后安装
                  </div>
                  <div class="service-remark line2">
                    为符合安装条件的平台自营商品提供上门安装服务
                  </div>
                </div>
                <div class="acea-row">
                  <div class="pictrue logo">
                    <img src="@assets/images/箭头.png" class="image" />
                  </div>
                </div>
              </div>
            </li>
          </template>
        </template>
        <template v-if="evaluate === '2' || evaluate === '3'">
          <li
            @click="
              $router.push({ path: '/workOrder/create/3/' + orderCon.orderId })
            "
          >
            <div class="acea-row">
              <div class="pictrue logo">
                <img src="@assets/images/维修.png" class="image" />
              </div>
              <div class="text acea-row row-between logotext">
                <div class="name line2">
                  维修服务
                </div>
                <div class="service-remark line2">
                  为平台自营商品提供上门维修服务
                </div>
              </div>
              <div class="acea-row">
                <div class="pictrue logo">
                  <img src="@assets/images/箭头.png" class="image" />
                </div>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.evaluate-con {
  padding: 0.3rem 0.1rem;
  background-color: #f0f0f0;
}
.evaluate-con .titleText {
  width: 100%;
  padding: 0 0 0.23rem 0;
  font-weight: bold;
  font-size: 0.26rem;
}
.goodsStyle {
  border-radius: 18px;
  padding: 0.22rem 0.22rem 0.26rem 0.22rem;
  margin-bottom: 0.15rem;
}
.goodsStyle .text {
  font-size: 0.22rem;
  font-weight: bold;
  color: #000;
}
.goodsStyle .sku {
  width: 100%;
  color: #8f8f8f;
  font-weight: normal;
  font-size: 0.2rem;
}
.goodsStyle .logo {
  position: absolute;
  top: 25%;
  width: 0.38rem;
  height: 0.38rem;
}

.goodsStyle li {
  margin: 0.2rem 0 0.3rem 0;
}

.goodsStyle .acea-row {
  position: relative;
}

.goodsStyle .logotext {
  margin-left: 0.5rem;
  font-size: 0.26rem;
}

.goodsStyle .service-remark {
  width: 100%;
  color: #8f8f8f;
  font-weight: normal;
  margin-top: 0.04rem;
  font-size: 0.2rem;
}
</style>
<script>
import { postOrderProduct } from "@api/store";
import { mapGetters } from "vuex";

const NAME = "WorkOrderAdd";

export default {
  name: NAME,
  components: {},
  props: {},
  data: function() {
    return {
      orderCon: {
        productInfo: {}
      },
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      unique: this.$route.params.id,
      evaluate: this.$route.params.evaluate
    };
  },
  mounted: function() {
    this.getOrderProduct();
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME && this.unique !== n.params.id) {
        this.unique = n.params.id;
        this.getOrderProduct();
      }
    }
  },
  methods: {
    getOrderProduct: function() {
      let that = this,
        unique = this.$route.params.id;
      if (unique && unique !== "-1") {
        postOrderProduct(unique).then(res => {
          that.orderCon = res.data;
        });
      } else {
        this.orderCon.orderId = "-1";
      }
    }
  }
};
</script>
